/**
 * Prefixed, sortable-ish unique ids. Uses crypto.randomUUID when available,
 * with a fallback for older runtimes.
 */
export function uid(prefix = ''): string {
  const rand =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
  return prefix ? `${prefix}_${rand}` : rand;
}

/** Short human-facing reference, e.g. order #A3F9. */
export function shortRef(): string {
  return Math.random().toString(16).slice(2, 6).toUpperCase();
}
